import React from 'react';
import PropTypes from 'prop-types';

import styles from './Lightbox.scss';
import CloseIcon from 'Static/icons/close-x.svg';
import buildingImgUri from './graphic-create-class.png';

const getGraphicUri = type => {
  if (type === 'create-class') {
    return (
      <img
        src={buildingImgUri}
        alt="an illustration of the building with alternating colors in each window"
        className="Lightbox__graphic"
      />
    );
  }
  return null;
};

class Lightbox extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClick, false);
    window.addEventListener('keyup', this.handleKeyUp, false);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleClick);
    window.removeEventListener('keyup', this.handleKeyUp, false);
    this.props.closeHandler();
  }

  handleKeyUp(e) {
    if (e.key === 'Escape') this.props.closeHandler();
  }

  handleClick(e) {
    const clickedTheLightbox = e.target.classList.contains('Lightbox');
    if (clickedTheLightbox && this.props.visible) this.props.closeHandler();
    return false;
  }

  render() {
    const { children, type, closeHandler, visible, header } = this.props;
    const visibleClass = visible ? ' is-visible' : ' is-hidden';
    const typeClass = type ? ` Lightbox--${type}` : '';
    const graphic = getGraphicUri(type);
    return (
      <div className={`Lightbox${visibleClass}${typeClass}`}>
        <div className="Lightbox__container">
          {closeHandler ? (
            <button
              type="button"
              className="Lightbox__close-button"
              onClick={closeHandler}
            >
              <CloseIcon className="Lightbox__close-icon" />
            </button>
          ) : null}
          <div className="Lightbox__content">
            {header ? <div className="Lightbox__header">{header}</div> : null}
            {visible ? children : null}
          </div>
          {graphic}
        </div>
      </div>
    );
  }
}

Lightbox.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  closeHandler: PropTypes.func,
  visible: PropTypes.bool.isRequired,
  header: PropTypes.node,
};

export default Lightbox;
